import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCancelOrderMutation = createMutationHook(OrderApiClient.cancelOrder, {
  mutationKey: ['cancelOrder'],
})
